<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>

      <form>
        <v-layout row wrap>
          <br />
          <v-flex xs12>
            <v-text-field
              label="Item requst form"
              @click="pickFile"
              v-model="fileName"
              prepend-icon="attach_file"
              hint="JPG/PNGファイル"
            ></v-text-field>
            <input
              id="image"
              accept="image/*"
              type="file"
              ref="file"
              style="display: none"
              value="発注依頼書を選択"
              @change="onFileChange($event)"
            />
          </v-flex>
        </v-layout>
      </form>

      <div style="height: 35px;"></div>
      <div style="display:table;width: 100%;">
        <div style="height: 143px; width: 100%; border: 1px solid #c7c7c7; background-color: #ffffff; display: table-cell; vertical-align: middle;">
          <div v-if="dispEmptyText">
            {{ $t('sales.selected-image-disp-here') }}
          </div>
          <img style="width: 100%;" :src="imageData" v-if="imageData" />
        </div>
      </div>

      <div style="height: 35px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-btn block class="ma-2" :loading="loading1" :disabled="loading1" color="error" @click="fileUpload()" >
            <v-icon class="ma-2" dark>cloud_upload</v-icon>
            商品イメージ登録
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-item-maintenance' }" >{{ $t('back-btn') }}</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    // 前画面からの情報を自身のdataに保持
    // this.selectedStore = this.$route.params.selectedStore
    // this.shippingDate = this.$route.params.shippingDate
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }

      if (files.length > 0) {
        this.dispEmptyText = false
        const file = files[0]
        const reader = new FileReader()
        reader.onload = e => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    pickFile() {
      this.$refs.file.click()
    },
    fileUpload() {
      let thisObj = this
      thisObj.loading1 = true
      // FormData を利用して File を POST する
      let formData = new FormData()
      formData.set('storeCode', this.selectedStore.storeCode)
      formData.set('shippingDate', this.shippingDate.replace(/\//g, ''))
      console.log('あっぷろーど')
      formData.append('type', 'image/*')
      formData.append('orderFile', this.targetFile)

      // var imagefile = document.querySelector('#image')
      // formData.append('orderFile', imagefile.files[0])

      console.log(this.targetFile)

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'sales/new-order-send'
      }

      ServerApiCallService.sendOrderImage(formData, sendContext)

        .then(response => {
          thisObj.loading1 = false
        })
        .catch(error => {
          //   console.log('There was an error:', error.response)
          thisObj.loading1 = false
          //   this.$parent.$parent.$parent.showResultDialog(
          //     '画像送信中にエラーが発生しました',
          //     null
          //   )
        })
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedStore: state => state.salesSession.menuSelectedStore
    }),
    shippingDate: {
      get() {
        return this.$store.state.salesSession.orderSelectedShippingDate
      },
      set(value) {
        this.$store.commit('SET_ORDER_SELECTED_SHIPPING_DATE', value)
      }
    }
  },
  data() {
    return {
      loading1: false,
      imageData: '',
      dispEmptyText: true,
      storeCode: '',
      targetFile: '',
      fileName: '',
      // storeCode: '',
      // arrivalDate: '',
      post: {
        type: '',
        content: '',
        uid: '',
        uploadedImages: []
      }
    }
  }
}
</script>
